module.exports = __webpack_public_path__ + "img/two2Blue.ed1af0c0.png";